var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-and-print", {
        attrs: {
          data: _vm.data,
          field: _vm.params.colDef.field,
          "use-route": _vm.attrs.useRoute,
          "use-print": _vm.attrs.usePrint,
          "route-name": _vm.attrs.routeName,
          "route-param-keys": _vm.attrs.routeParamKeys,
          "route-title": _vm.attrs.routeTitle,
          "route-permissions": _vm.attrs.routePermissions,
          "extra-route-params": _vm.attrs.extraRouteParams,
          "extra-route-data": _vm.attrs.extraRouteData,
          "print-method": function() {
            return _vm.attrs.printMethod(
              _vm.params.data[_vm.params.colDef.field]
            )
          }
        },
        on: {
          linkClick: function($event) {
            _vm.showPopover = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }